import { cn } from '@/infra'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-testid="skeleton"
      data-slot="skeleton"
      className={cn('bg-primary/10 animate-pulse rounded-md', className)}
      {...props}
    />
  )
}

export { Skeleton }
